import { render, staticRenderFns } from "./PlatformView.vue?vue&type=template&id=33e069e8&scoped=true&"
var script = {}
import style0 from "./PlatformView.vue?vue&type=style&index=0&id=33e069e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e069e8",
  null
  
)

export default component.exports